import React from 'react'

const STRReports = () => {
  return (
    <div>
      
    </div>
  )
}

export default STRReports
